import { Box, Divider } from "@material-ui/core"
import * as R from "ramda"
import { useMemo } from "react"
import type { ReactElement } from "react"

import { ChapterZone } from "../../../models"
import type { Chapter, LinkChapter } from "../../../redux"
import { CardTemplateContainer } from "../../atoms"
import { ChapterCard } from "../../molecules"

import "./chapter-overview.styles.scss"

export interface IChapterOverviewProps {
  chapters: Chapter[]
  linkChapters: LinkChapter[]
  hideBottom?: boolean
  onNavigate?: (chapter: Chapter | LinkChapter) => void
}

type OverviewChapter = Chapter | LinkChapter

export function ChapterOverview(props: IChapterOverviewProps): ReactElement {
  const { chapters, linkChapters, hideBottom, onNavigate } = props
  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO in a later PR
  const topZone: OverviewChapter[] = useMemo(() => getChaptersFromZone(ChapterZone.TOP), [chapters])
  // biome-ignore lint/correctness/useExhaustiveDependencies: TODO in a later PR
  const bottomZone: OverviewChapter[] = useMemo(() => getChaptersFromZone(ChapterZone.BOTTOM), [chapters])

  function getChaptersFromZone(zone: ChapterZone): OverviewChapter[] {
    return R.sortWith([R.ascend(R.prop("order"))])(
      [...chapters, ...linkChapters].filter((chapter: OverviewChapter) => chapter.zone === zone)
    ) as Chapter[]
  }

  return (
    <Box className="chapter-overview" data-mdat-module="chapter-overview">
      <CardTemplateContainer columns={4}>
        {topZone.map((chapter: Chapter) => (
          <ChapterCard onNavigate={onNavigate} key={chapter.id} chapter={chapter} testId={`chapter-card-top-${chapter.id}`} />
        ))}
      </CardTemplateContainer>
      {!hideBottom && (
        <>
          <Divider className="chapter-zone-divider" />
          <CardTemplateContainer columns={4}>
            {bottomZone.map((chapter: Chapter) => (
              <ChapterCard onNavigate={onNavigate} key={chapter.id} chapter={chapter} testId={`chapter-card-bottom-${chapter.id}`} />
            ))}
          </CardTemplateContainer>
        </>
      )}
    </Box>
  )
}
